export const sortSizes = (sizes: string[]) => {
    const sizeOrder: Record<string, number> = {
        'XXS': 1, '2XS': 1, 'XS': 2, 'S': 3, 'M': 4, 'L': 5, 'XL': 6, 'XXL': 7, '2XL': 7, '3XL': 8, '4XL': 9, '5XL': 10
    };
    
    return [...sizes].sort((a, b) => {
        const orderA = sizeOrder[a.toUpperCase()] || 99;
        const orderB = sizeOrder[b.toUpperCase()] || 99;
        
        if (orderA !== orderB) return orderA - orderB;
        
        // Si no están en el mapa, intentar orden numérico
        const numA = parseInt(a);
        const numB = parseInt(b);
        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
        }
        
        return a.localeCompare(b);
    });
};
